// Mock data for DumanginADM Landing Page

export const companyInfo = {
  name: "DumanginADM",
  slogan: "Sua Marca, Nossa Missão",
  tagline: "Administração & Marketing",
  description: "A DumanginADM é uma empresa de Administração e Marketing criada para cuidar do negócio do cliente como se fosse próprio. Atuamos de forma estratégica na gestão da empresa, na construção da imagem e no fortalecimento da marca, unindo organização, posicionamento e crescimento sustentável.",
  fullDescription: "Mais do que executar tarefas, a DumanginADM oferece visão estratégica, planejamento e acompanhamento contínuo, ajudando empresas a se posicionarem melhor, venderem mais e crescerem de forma estruturada.",
  contact: {
    name: "Lucas Dumangin",
    phone: "(15) 99168-9601",
    whatsapp: "5515991689601",
    location: "Sorocaba - SP"
  },
  logos: {
    horizontal: "https://customer-assets.emergentagent.com/job_ce368546-0a3c-4601-8285-3d4672a1292a/artifacts/6a2sg22j_logo%20horizontal.GOODquality.jpg",
    principal: "https://customer-assets.emergentagent.com/job_ce368546-0a3c-4601-8285-3d4672a1292a/artifacts/socc2mmg_logoprincipal.GOODquality.jpg",
    symbol: "https://customer-assets.emergentagent.com/job_ce368546-0a3c-4601-8285-3d4672a1292a/artifacts/bphfbgv2_logosimbolo.GOODquality.jpg"
  }
};

export const services = [
  {
    id: 1,
    title: "Gestão Empresarial",
    description: "Administração estratégica do seu negócio, cuidando da sua empresa como se fosse nossa. Planejamento, organização e controle para resultados sustentáveis.",
    icon: "briefcase"
  },
  {
    id: 2,
    title: "Branding",
    description: "Construção e fortalecimento da identidade da sua marca. Garantimos coerência, autoridade e posicionamento único no mercado.",
    icon: "palette"
  },
  {
    id: 3,
    title: "SEO & Marketing Digital",
    description: "Estratégias de otimização para buscadores e marketing digital focado em atração, relacionamento e conversão de clientes.",
    icon: "search"
  },
  {
    id: 4,
    title: "Inbound Marketing",
    description: "Atração de clientes através de conteúdo relevante. Criamos estratégias que geram valor e constroem relacionamentos duradouros.",
    icon: "magnet"
  },
  {
    id: 5,
    title: "Gestão de Conteúdo",
    description: "Planejamento e criação de conteúdo estratégico para fortalecer sua presença digital e engajar seu público-alvo.",
    icon: "edit"
  },
  {
    id: 6,
    title: "Consultoria Estratégica",
    description: "Visão estratégica e acompanhamento contínuo para posicionar sua empresa melhor no mercado e impulsionar vendas.",
    icon: "lightbulb"
  }
];

export const portfolioItems = [
  {
    id: 1,
    clientName: "Café Origem",
    industry: "Cafeteria & Gastronomia",
    description: "Desenvolvimento completo da identidade visual para cafeteria artesanal. Criação de logo, paleta de cores, tipografia e aplicações em embalagens e papelaria.",
    deliverables: ["Logo", "Manual da Marca", "Papelaria", "Embalagens"],
    colors: ["#8B4513", "#F5E6D3", "#2C1810", "#D4A574"],
    year: "2024",
    image: null
  },
  {
    id: 2,
    clientName: "Tech Solutions",
    industry: "Tecnologia & Inovação",
    description: "Rebranding completo para empresa de soluções tecnológicas. Nova identidade moderna que transmite inovação e confiabilidade.",
    deliverables: ["Rebranding", "Manual da Marca", "Apresentação Institucional", "Templates Digitais"],
    colors: ["#0066CC", "#00D4AA", "#1A1A2E", "#FFFFFF"],
    year: "2024",
    image: null
  },
  {
    id: 3,
    clientName: "Bella Vida Estética",
    industry: "Beleza & Bem-estar",
    description: "Criação de marca sofisticada para clínica de estética. Identidade que transmite elegância, cuidado e resultados.",
    deliverables: ["Logo", "Manual da Marca", "Cartão de Visita", "Redes Sociais"],
    colors: ["#C9A962", "#1E2A3A", "#F8F5F0", "#8B7355"],
    year: "2024",
    image: null
  }
];

export const navigationItems = [
  { id: "home", label: "Início", href: "#home" },
  { id: "about", label: "Sobre", href: "#about" },
  { id: "services", label: "Serviços", href: "#services" },
  { id: "portfolio", label: "Portfolio", href: "#portfolio" },
  { id: "contact", label: "Contato", href: "#contact" }
];
